import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { Link } from '../../../interfaces/strapi';

@Component({
    selector: 'app-cms-link',
    templateUrl: './cms-link.component.html',
    styleUrls: ['./cms-link.component.scss'],
    imports: [
        NgIf,
        RouterLinkActive,
        RouterLink,
        NgTemplateOutlet,
    ],
})
export class CmsLinkComponent implements OnInit, OnChanges {
  @Input() public link: Link | undefined;

  @Input() public class: string | undefined;

  @Input() public routeArrow: boolean = false;

  @Input() public linkArrow: boolean = false;

  public linkUrl: string | undefined = undefined;

  public linkTarget = '';

  public route: string | undefined = undefined;

  constructor(public readonly userService: UserService) {}

  ngOnInit(): void {
    if (this.link) {
      if (this.link.route === null || this.link.route === '') {
        if (this.link.link) {
          this.linkTarget = this.link.link;
        }
      } else {
        this.route = this.link.route;
      }
    }
  }

  ngOnChanges(_: SimpleChanges) {
    if (this.routeArrow || this.linkArrow) {
      if (this.class) {
        this.class += ' with-icon';
      } else {
        this.class = 'with-icon';
      }
    }
  }
}
